import React from 'react'

import { Action, Changes } from 'services/apiTypes/deck.types'
import { CardType } from 'types/deck'

type ChangeMessageProps = { message: React.ReactNode; change: React.ReactNode; messageSecond?: boolean }

const ChangeMessage = ({ message, change, messageSecond = false }: ChangeMessageProps) => {
  // prettier-ignore
  if (messageSecond) return <>&nbsp;<b>{change}</b>&nbsp;{message}&nbsp;</>

  // prettier-ignore
  return <>&nbsp;{message}&nbsp;<b>{change}</b>&nbsp;</>
}

export function generateHumanLog(changes: Changes, action: Action, card: CardType | null): React.ReactNode[] {
  const readableChanges = []

  const makeCategoryWords = (prepositionFirst = false) => {
    const categories = changes.categories || []

    if (!categories.length) return `N/A`

    const categoriesString = categories.join(', ')

    if (categories.length > 1 && prepositionFirst)
      return <ChangeMessage message="categories to" change={categoriesString} />
    if (categories.length > 1 && !prepositionFirst)
      return <ChangeMessage message="categories" change={categoriesString} messageSecond />

    if (categories.length === 1 && prepositionFirst)
      return <ChangeMessage message="category to" change={categoriesString} />
    if (categories.length === 1 && !prepositionFirst)
      return <ChangeMessage message="category" change={categoriesString} messageSecond />

    return 'N/A'
  }

  // prettier-ignore
  if (action === 'add' && changes.categories) readableChanges.push(<>&nbsp;to the deck (in the {makeCategoryWords()})</>)
  if (action === 'add') return readableChanges

  // prettier-ignore
  if (action === 'remove' && changes.categories) readableChanges.push(<>&nbsp;from the deck (from the {makeCategoryWords()})</>)
  if (action === 'remove') return readableChanges

  // prettier-ignore
  if (changes.oldCardId) readableChanges.push(<ChangeMessage message="printing to" change={`${card?.set} (${card?.collectorNumber})`} />)
  if (changes.categories) readableChanges.push(makeCategoryWords(true))
  if (changes.modifier) readableChanges.push(<ChangeMessage message="finish to" change={changes.modifier} />)
  if (changes.quantity) readableChanges.push(<ChangeMessage message="quantity to" change={changes.quantity} />)
  if (changes.customCmc) readableChanges.push(<ChangeMessage message="custom CMC to" change={changes.customCmc} />)
  if (changes.companion) readableChanges.push(<ChangeMessage message="companion to" change={changes.companion} />)
  if (changes.label)
    readableChanges.push(<ChangeMessage message="color tag to" change={changes.label.split(',')[0] || 'Default'} />)

  return readableChanges
}
